import { Link } from 'react-router-dom';
import MailerLiteForm from '../parts/MailerLiteForm';
const Footer = () => {


  return (
    <footer className="bg-light pt-4">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-lg-4 col-xl-4 mb-4">
            <h6 className="text-uppercase fw-bold">Usluge</h6>
            <hr className="mb-4 mt-0 d-inline-block mx-auto" />
            <p><Link to="/ZvucnaMasaza" className="text-dark">Zvučna masaža</Link></p>
            <p><Link to="/TherapyYoga" className="text-dark">Therapy Yoga</Link></p>
            <p><Link to="/ThetaHealing" className="text-dark">Theta Healing</Link></p>
  
          </div>
          <div className="col-md-4 col-lg-4 col-xl-4 mb-4">
            <h6 className="text-uppercase fw-bold">Kontakt</h6>
            <hr className="mb-4 mt-0 d-inline-block mx-auto" />
            <p><i className="fas fa-home me-2"></i> Ulica Drage Gervaisa 22, Pula</p>
            <p><i class="fa-solid fa-envelope me-2"></i><a href="mailto:info@zenplacepula.com"> info@zenplacepula.com</a></p>
            <p> <a href="tel:+385993146478"> <i className="fas fa-phone me-2 phone-link"></i>  +385 99 3146478</a></p>
            <p>
              <a
                href="https://www.facebook.com/ZenplaceStudioForBodyMindSoul"
                target="_blank"
                rel="noopener noreferrer"
                className="text-dark me-3"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/zen_place_pula/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-dark me-3"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </p>
          </div> 
        <div className="col-md-4 col-lg-4 col-xl-4 mb-4">
          <MailerLiteForm />
          </div> 
      </div>
      </div>
      
    </footer>
  );
};
export default Footer;
